export enum ITodoCardStatus {
  success = 'success',
  pending = 'pending'
};
